import React from 'react';
import Styles from './styles.js';
export default function AvailableOptions({ title, children }) {
  return (
    <div className=" pb-10 ">
      <h2 className="AO-head-title text-xl lg:text-2xl border-b-2 pb-3 mb-8 ">{title}</h2>
      <div className=" flex justify-center items-center  sm:px-6 px-4">{children}</div>
      <Styles />
    </div>
  );
}
